// @flow

import { type WizardPageChosenOptions, type Wizard, type WizardPage, type ProductMessage, type WizardPageData, type SingleChoiceData, type MultipleChoiceData, type InputData, type RangeData, type ProductData, type WizardSorting } from '@chatchamp/chatchamp-types'

type PageId = number
export type SelectedOptions = {
  [PageId]: WizardPageChosenOptions
}

export type ScrollDirection = 'up' | 'down'

export type NotificationType = 'error'

export type Notification = {
  type: NotificationType,
  message: string
}

export type State = {
  customerId: string,
  subscriberId: string,
  parentUrl: string,
  integrationId: string,
  customerConfig: Object,
  wizard: Wizard,
  recommendedProducts: ?ProductMessage,
  isLoadingProducts: boolean,
  isLandingPage: boolean,
  isSavingWizardPageAnswer: boolean,
  // wizard pages
  wizardPageIndex: number,
  wizardPageData: ?WizardPageData<SingleChoiceData | MultipleChoiceData | InputData | RangeData | ProductData>,
  wizardPages: Array<WizardPage>,
  visitedPageIds: Array<PageId>,
  selectedOptions: SelectedOptions,
  hiddingProducts: boolean,
  sort: WizardSorting,
  scrollDirection: ?ScrollDirection,
  latestLoadedProducts: Array<Object>,
  productAddingToCart: ?string,
  routineAddingToCart: boolean,
  cartProducts: Array<string>,
  notification: ?Notification,
  isEmbedded: boolean
}

export function createState (customerId: string, subscriberId: string, parentUrl: string, integrationId: string): State {
  return {
    customerId,
    subscriberId,
    parentUrl,
    integrationId,
    customerConfig: {},
    recommendedProducts: null,
    isLandingPage: true,
    wizardPageIndex: 0,
    selectedOptions: {},
    wizardPages: [],
    visitedPageIds: [],
    isSavingWizardPageAnswer: false,
    wizardPageData: null,
    wizard: {},
    isLoadingProducts: false,
    hiddingProducts: false,
    sort: 'utility:desc',
    scrollDirection: null,
    latestLoadedProducts: [],
    productAddingToCart: null,
    routineAddingToCart: false,
    cartProducts: [],
    notification: null,
    isEmbedded: false
  }
}
